import React, { useState, useRef, useEffect, useCallback } from 'react';

/* ── Brand SVG icons (18×18) ── */
const LinkedInIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#0A66C2">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const IndeedIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#2164f3">
    <path d="M11.566 21.882v-8.609c0-.408.122-.7.408-.934.29-.233.637-.35 1.05-.35.404 0 .754.117 1.044.35.286.234.408.526.408.934v8.609c0 .816-.466 1.458-1.227 1.866-.462.245-.87.252-1.218.252-.347 0-.755-.007-1.217-.252-.762-.408-1.227-1.05-1.227-1.866h1.979zm1.458-11.398c-.816 0-1.517-.29-2.1-.87-.58-.58-.87-1.284-.87-2.1 0-.816.29-1.516.87-2.1.583-.58 1.284-.87 2.1-.87.816 0 1.516.29 2.1.87.58.584.87 1.284.87 2.1 0 .816-.29 1.52-.87 2.1-.584.58-1.284.87-2.1.87z"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#25D366">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const EmailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#EA4335">
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);

const CopyIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#0d9488">
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
  </svg>
);

const BRAND_ICONS = { copy: CopyIcon, linkedin: LinkedInIcon, indeed: IndeedIcon, whatsapp: WhatsAppIcon, email: EmailIcon };

// "copy" target has no `getUrl`, clipboard-only, no platform redirect. Mano's feedback
// (2026-05-13 test): platform-targets all require login and open external tabs, which
// felt heavy when she just wanted to paste the text somewhere else. This sits FIRST in
// the list as the lowest-friction path.
const SHARE_TARGETS = [
  {
    id: 'copy',
    label: 'Kopieer tekst',
    getUrl: null, // copy-only, no platform open
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    getUrl: () => 'https://www.linkedin.com/post/new',
  },
  {
    id: 'indeed',
    label: 'Indeed',
    getUrl: () => 'https://employers.indeed.com/jobs/post',
  },
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    getUrl: (text) => `https://wa.me/?text=${encodeURIComponent(text)}`,
  },
  {
    id: 'email',
    label: 'E-mail',
    getUrl: (text, title) => {
      const subject = title || 'Vacaturetekst';
      return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text)}`;
    },
  },
];

export default function ShareMenu({ getText, getTitle, showToast }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  // Close on click outside
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open]);

  const handleShare = useCallback((target) => {
    const text = getText();
    if (!text) {
      showToast('Nog geen tekst om te delen', 'info');
      setOpen(false);
      return;
    }

    const title = getTitle?.() || '';

    // Copy-only target: no platform open, just clipboard + confirmation toast.
    if (!target.getUrl) {
      navigator.clipboard.writeText(text).then(() => {
        showToast('Vacaturetekst gekopieerd, plak nu waar je wilt', 'success');
      });
      setOpen(false);
      return;
    }

    // Platform target: copy text first, then open the platform tab.
    navigator.clipboard.writeText(text).then(() => {
      showToast(`Tekst gekopieerd! Plak in ${target.label} met Ctrl+V`, 'success');
      window.open(target.getUrl(text, title), '_blank', 'noopener');
    });

    setOpen(false);
  }, [getText, getTitle, showToast]);

  return (
    <div className="share-menu" ref={menuRef}>
      <button
        type="button"
        className="document-panel__action-btn share-menu__trigger"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-haspopup="true"
      >
        <span className="material-icons">share</span>
        Delen
      </button>

      {open && (
        <div className="share-menu__dropdown">
          {SHARE_TARGETS.map((target) => {
            const Icon = BRAND_ICONS[target.id];
            return (
              <button
                key={target.id}
                type="button"
                className="share-menu__item"
                onClick={() => handleShare(target)}
              >
                <span className="share-menu__icon"><Icon /></span>
                <span className="share-menu__label">{target.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
